import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getAnalytics, logEvent } from 'firebase/analytics';
import LoginPage from './components/screens/Auth/Login';
import LaunchConsent from './components/screens/Onboarding/LaunchConsent';
import Dashboard from './components/screens/App/Dashboard';
import LogoutPage from './components/screens/Auth/Logout';
import LinkedAccounts from './components/screens/App/LinkedAccounts';
import Consented from './components/screens/Onboarding/Consented';
import RoundupAccounts from './components/screens/Onboarding/RoundUpAccounts';
import FundingAccounts from './components/screens/Onboarding/FundingAccounts';
import Finished from './components/screens/Onboarding/Finished';
import Support from './components/screens/App/Support';
import History from './components/screens/App/History';
import { analytics } from './firebaseConfig';
import Terms from './components/screens/App/Terms';
import { Analytics } from "@vercel/analytics/react"
import SecurityVerification from './components/screens/Auth/SecurityVerification';
import ConsentedVerified from './components/screens/Onboarding/ConsentedVerified';
import ExtendConsent from './components/screens/Auth/ExtendConsent';
import RedirectFromBasiq from './components/screens/Onboarding/Redirect';
import ExpiredConsent from './components/screens/Auth/ExpiredConsent';
import CloseWindow from './components/screens/Onboarding/CloseWindow';




const App = () => {


  return (
    <Router>
      <Routes>
        <Route path="/" element={<LaunchConsent />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/redirect" element={<RedirectFromBasiq />} />
        <Route path="/roundup-accounts" element={<RoundupAccounts />} />
        <Route path="/funding-accounts" element={<FundingAccounts />} />
        <Route path="/finished" element={<Finished />} />
        <Route path="/close-window" element={<CloseWindow />} />
        <Route path="/extend-consent/:email" element={<ExtendConsent />} />
        <Route path="/expired-consent/:email" element={<ExpiredConsent />} />
      

      </Routes>
      <Analytics />
    </Router>
  );

};
<Analytics />

export default App;
